/**
 * PLP Mobile Carousel
 * Changes images on click and swipe, with infinite loop and progress indicator.
 */
document.addEventListener('DOMContentLoaded', function() {
  function initMobileCarousels(container = document) {
    const carousels = container.querySelectorAll('[data-mobile-carousel]:not([data-initialized])');
    
    carousels.forEach(carousel => {
      carousel.dataset.initialized = 'true';
      
      let touchstartX = 0;
      let touchstartY = 0;
      let touchendX = 0;
      let touchendY = 0;

      function updateSlide(direction) {
        const slider = carousel.querySelector('[data-mobile-carousel-slider]');
        const items = carousel.querySelectorAll('.ProductItem__MobileCarouselItem');
        const dots = carousel.querySelectorAll('.ProductItem__MobileCarouselIndicatorDot');
        
        if (items.length <= 1) return;
        
        // Find current active dot index
        let currentIndex = Array.from(dots).findIndex(dot => dot.classList.contains('is-active'));
        
        // Remove active state from current dot
        dots[currentIndex].classList.remove('is-active');
        
        // Calculate next index (infinite loop)
        currentIndex = (currentIndex + direction + items.length) % items.length;
        
        // Add active state to next dot
        dots[currentIndex].classList.add('is-active');

        // Apply slide transition
        const percentage = -(currentIndex * 100);
        slider.style.transform = `translateX(${percentage}%)`;
      }

      // Click handling
      carousel.addEventListener('click', function(e) {
        // Only trigger if the feature flag is enabled on the body
        if (document.body.getAttribute('data-swipeable-images') !== 'true') return;

        // Only trigger on mobile
        if (window.innerWidth > 640) return;

        // Prevent navigation to PDP
        e.preventDefault();
        e.stopPropagation();
        
        updateSlide(1);
      });

      // Swipe handling
      carousel.addEventListener('touchstart', function(e) {
        touchstartX = e.changedTouches[0].screenX;
        touchstartY = e.changedTouches[0].screenY;
      }, {passive: true});

      carousel.addEventListener('touchend', function(e) {
        touchendX = e.changedTouches[0].screenX;
        touchendY = e.changedTouches[0].screenY;
        
        const deltaX = touchendX - touchstartX;
        const deltaY = touchendY - touchstartY;

        // Check if it's a horizontal swipe
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 30) {
            // Only trigger if the feature flag is enabled on the body
            if (document.body.getAttribute('data-swipeable-images') !== 'true') return;
            // Only trigger on mobile
            if (window.innerWidth > 640) return;

            e.preventDefault();
            e.stopPropagation();

            if (deltaX < 0) {
                updateSlide(1); // Swipe left -> Next
            } else {
                updateSlide(-1); // Swipe right -> Previous
            }
        }
      }, {passive: false});
    });
  }

  // Initial init
  initMobileCarousels();

  // MutationObserver to handle infinite scroll and AJAX filtering
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        shouldInit = true;
      }
    });
    if (shouldInit) {
      initMobileCarousels();
    }
  });

  const mainContent = document.querySelector('#main');
  if (mainContent) {
    observer.observe(mainContent, { childList: true, subtree: true });
  }
});
